import React from "react";
import PublicFormGrid from "../../../components/publicForm/PublicFormGrid";
import PublicFormSection from "../../../components/publicForm/PublicFormSection";
import RffBooleanToggleField from "../../../components/finalForm/inputs/RffBooleanToggleField";
import RffDateField from "../../../components/finalForm/inputs/RffDateField";
import RffPercentField from "../../../components/finalForm/inputs/RffPercentField";
import RffSelectAutocompleteField from "../../../components/finalForm/inputs/RffSelectAutocompleteField";
import RffTextField from "../../../components/finalForm/inputs/RffTextField";
import RffConditional from "../../../components/finalForm/shared/RffConditional";
import { selectOptionsEntityType } from "../../../constants/selectOptions/selectOptionsEntityType";
import { selectOptionsUsaStates } from "../../../constants/selectOptions/selectOptionsUsaStates";

/**
 * Step 5 — the borrowing entity, existing or planned.
 *
 * The section renders untitled: this step has only one section, and the step
 * header above already names it. A second heading just repeats itself.
 */
const StepBorrowingEntities = () => (
  <PublicFormSection>
    <PublicFormGrid>
      <RffBooleanToggleField
        required
        name="applicantHasExistingEntity"
        label="Do you have an existing entity, such as an LLC, that will be used for this transaction?"
      />

      {/* Planned entity */}
      <RffConditional field="applicantHasExistingEntity" value={false}>
        {/* Percent field on both branches so applicantEntityPercentOwnership is
            stored at one scale regardless of which path the applicant took. */}
        <RffPercentField
          name="applicantEntityPercentOwnership"
          label="What percentage ownership of the borrower entity do you expect to own once established?"
        />
        <RffSelectAutocompleteField
          name="entityStateOfOrganization"
          label="What will be the US State of Organization for the entity?"
          options={selectOptionsUsaStates}
          size={6}
        />
        <RffSelectAutocompleteField
          name="entityType"
          label="Planned entity type?"
          options={selectOptionsEntityType}
          size={6}
        />
        <RffBooleanToggleField
          name="entityAssets"
          label="Will the entity be established as a single asset entity? I.e. an entity set up to purchase real estate with ownership of a single property?"
        />
      </RffConditional>

      {/* Existing entity */}
      <RffConditional field="applicantHasExistingEntity" value={true}>
        <RffTextField name="entityName" label="Entity Name" size={6} />
        <RffTextField name="entityEINNumber" label="EIN Number" size={6} />
        <RffPercentField
          name="applicantEntityPercentOwnership"
          label="What percentage ownership of the borrower entity do you own?"
        />
        <RffSelectAutocompleteField
          name="entityStateOfOrganization"
          label="Entity State Of Organization"
          options={selectOptionsUsaStates}
          size={4}
        />
        <RffSelectAutocompleteField
          name="entityType"
          label="Entity Type"
          options={selectOptionsEntityType}
          size={4}
        />
        <RffDateField
          name="entityOrganizationDate"
          label="Entity Organization Date"
          size={4}
        />
        <RffBooleanToggleField
          name="entityAssets"
          label="Is this a single asset entity? I.e. an entity set up to purchase real estate with ownership of a single property?"
        />
      </RffConditional>
    </PublicFormGrid>
  </PublicFormSection>
);

export default StepBorrowingEntities;
